import styled from '@emotion/styled';
import { TransparentButton } from '~Styles';

export const ActionButton = styled(TransparentButton)`
  text-transform: none;
  padding: 0;
  gap: 4px;
`;
